import { Line } from '@ant-design/plots'
import { Empty } from 'antd'
import dayjs from 'dayjs'

const groupDataByMonth = (data) => {
  const result = {}

  data.forEach(({ date, count }) => {
    const monthKey = dayjs(date).format('YYYY-MM')
    result[monthKey] = (result[monthKey] || 0) + count
  })

  return Object.entries(result)
    .sort(([a], [b]) => dayjs(a).unix() - dayjs(b).unix())
    .map(([monthKey, count]) => ({
      date: dayjs(monthKey, 'YYYY-MM').format('MMM YY'),
      count,
    }))
}

const DailyPostChart = ({ data, theme = 'classicDark', chartHeight = 200 }) => {
  const dailyData = data?.socialPostDaily ?? []

  if (dailyData.length === 0) {
    return (
      <div
        style={{
          height: chartHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Empty description="No data available" />
      </div>
    )
  }
  dailyData.sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix())

  const displayData =
    dailyData.length > 50 ? groupDataByMonth(dailyData) : dailyData
  const isMonthly = dailyData.length > 50

  const config = {
    theme,
    data: displayData,
    xField: 'date',
    yField: 'count',
    height: chartHeight,
    shapeField: 'smooth',
    axis: {
      y: { title: 'Total No. of Posts', grid: null },
      x: {
        grid: null,
      },
    },
    scale: {
      y: {
        domainMin: 0,
      },
    },
    xAxis: {
      label: {
        autoRotate: true,
        formatter: (val) =>
          isMonthly
            ? dayjs(val, 'YYYY-MM').format('MMM YYYY')
            : dayjs(val).format('DD MMM'),
      },
      tickCount: isMonthly ? undefined : 7,
    },

    interaction: {
      tooltip: {
        marker: false,
      },
    },
    style: {
      lineWidth: 2,
    },
  }

  return <Line {...config} />
}

export default DailyPostChart
